import { DataTableColumnHeader } from "@components/ui/data-table/DataTableColumnHeader";
import { formatDateFR } from "@/lib/format";
import { createColumn } from "@/lib/table/columnFactory";
import type { LeaveRequest } from "./types";

export const periodeColumn = createColumn<LeaveRequest>({
  id: "periode",
  header: ({ column }) => <DataTableColumnHeader column={column} title="Période" />,
  cell: ({ row }) => {
    const debut = new Date(row.original.dateDebut);
    const fin = new Date(row.original.dateFin);
    const debutStr = formatDateFR(debut);
    const finStr = formatDateFR(fin);
    const isJourneeComplete = row.original.isJourneeComplete;
    const isSameDay = debutStr === finStr;
    if (!isJourneeComplete && isSameDay) {
      const heureDebut = debut.toLocaleTimeString("fr-FR", {
        hour: "2-digit",
        minute: "2-digit",
      });
      const heureFin = fin.toLocaleTimeString("fr-FR", {
        hour: "2-digit",
        minute: "2-digit",
      });
      return `${debutStr} ${heureDebut} → ${heureFin}`;
    }
    return `${debutStr} - ${finStr}`;
  },
});
